import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { AuthService } from '@services/auth/auth.service';
import { AuthFormComponent } from '@shared/components/auth-form/auth-form.component';

@Component({
	selector: 'app-register',
	imports: [AuthFormComponent],
	templateUrl: './register.component.html',
	styleUrl: './register.component.scss',
})
export class RegisterComponent {
	isRegister: 5 = 5;
	errorMessage: string | null = null;
	showSuccessState = false;

	constructor(
		private authService: AuthService,
		private translocoService: TranslocoService,
		private router: Router,
	) {}

	onRegister(formData: { email?: string; password?: string; referralCode?: string }): void {
		this.errorMessage = null;

		if (!formData.email || !formData.password) {
			this.errorMessage = this.translocoService.translate('auth.errors.requiredFields');
			return;
		}

		this.authService
			.register({
				email: formData.email,
				password: formData.password,
				referralCode: formData.referralCode,
			})
			.subscribe({
				next: () => {
					this.showSuccessState = true;
				},
				error: (err) => {
					this.errorMessage = err.message || this.translocoService.translate('auth.errors.unknownError');
				},
			});
	}
}
